import React, { useState} from 'react'
import "./PhoneLogin.css";
import './Register.css'
import { Link, useHistory } from "react-router-dom";
import firebase from './firebase';
import Skblack from './Skblack.jpeg'
import { Modal, Button } from 'react-bootstrap';
import PhoneIcon from '@mui/icons-material/Phone';

function PhoneLogin() {
    const history = useHistory();
    const [showModal,setShowModal]=useState(false)
    const [phnumber,setPhnumber]=useState('')

    const handleClick=(e)=>{
        e.preventDefault()
        if(phnumber==''){
            alert('Please enter a number')

        }
        else{
            const recaptcha = new firebase.auth.RecaptchaVerifier('recaptcha');
        const number='+16505551234'
        firebase.auth().signInWithPhoneNumber(phnumber,recaptcha).then((e)=>{
            const code=prompt('enter otp','');
            alert('enter code')
            if(code==null) return;
            e.confirm(code).then((result)=>{
                console.log(result.user,'user')
                alert('Given Number verified')
                history.push('/')
            }).catch((err)=>{
                console.log('err is '+err.message+' '+err.code)
                alert('err'+err.message+' '+err.code)
            })
            
        }).catch((err)=>{
            console.log('Something is wrong. '+err.code+' or '+err.message)
            alert('Something is wrong. '+err.code+' or '+err.message)
        })
        }
        
    }

   
    return (
        <div className="login">
        <Modal
        show={showModal}
        onHide={() => {
            setShowModal(0)
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Login with mobile number</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Enter Your Phone Number : <input type='text'/>
          </Modal.Body>
        <Modal.Footer>
        </Modal.Footer>
      </Modal>
            <Link to="/">
                {/* "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Amazon_logo.svg/1024px-Amazon_logo.svg.png" */}
                <img className="login__logo" src={Skblack} />
            </Link>
            <div className="login__container">
                <form>
                    <h3 className='mb-2'>Login with mobile</h3>
                    {/* <h5><PhoneIcon/></h5>
                     */}
                     <p className='inputWithIcon'>
                     <input className='register__fname' type='text' placeholder='+919769******' onChange={(e)=>{setPhnumber(e.target.value)}}/>
                     <i className='email__icon'>
                     <PhoneIcon/>
                     </i>
                     </p>
                     
                    
                    <center><Link to='login'>
                    Back to login
                    </Link></center>

                    <button onClick={handleClick} type="submit" className="login__signInButton">Get OTP</button>
                </form>
                <div id='recaptcha'></div>
                
            </div>
        </div>
    )
}

export default PhoneLogin
